module.exports = __webpack_public_path__ + "img/sample_cabinet1.9228acd7.png";